import axios from "axios";

export const initDirectBookingForm = () => {
    initForm2();

    if (typeof TourArrayWithDates === 'undefined') {
        return
    }

    const selectTour = document.getElementById('select-tour');
    const selectDate = document.getElementById('select-date');
    const selectDateWrapper = document.getElementById('select-date-wrapper');

    if (!selectTour) {
        return
    }

    selectTour.addEventListener('change', function() {
        const selectedOption = this.selectedOptions[0];
        const selectedValue = selectedOption.getAttribute('data-id');
        const dates = TourArrayWithDates[selectedValue] || [];

        selectDate.innerHTML = '<option value="">Choose a date</option>';

        // console.log('dates', dates)

        dates[0].forEach(date => {
            const option = document.createElement('option');
            option.value = date['date'];
            option.textContent = date['date'] + ' - €' + date['price'];
            selectDate.appendChild(option);
        });


        if (dates[0].length === 0) {
            selectDate.innerHTML = '<option value="">No dates available</option>';
            selectDateWrapper.classList.add('inactive')
        } else {
            selectDateWrapper.classList.remove('inactive')
        }
    });
}

const initForm2= () => {
    const form = document.getElementById('direct-booking-form');
    const responseTag = document.getElementById('response');

    if (!form) {
        return
    }

    form.addEventListener('submit', function(e) {

        console.log('submitttt')
        form.classList.add('sending');
        e.preventDefault();

        const formData = new FormData(form);
        formData.append('action', 'submit_direct_booking_form');

        axios.post(ajaxUrl, formData)
            .then(function(response) {

                // if (typeof gtag === 'function') {
                //     gtag('event', 'direct_form_sent', {
                //         event_category: 'Forms',
                //         event_label: 'Direct Booking Form',
                //         value: 1
                //     });
                // }

                console.log(response);

                // WordPress wp_send_json_success()
                if (
                    response.data.success === true &&
                    response.data.data.redirect
                ) {
                    window.open(response.data.data.redirect, '_blank');
                    return;
                }

                responseTag.innerHTML = '<p>No booking link found.</p>';

                form.classList.remove('sending');
            })
            .catch(function(error) {

                responseTag.innerHTML =
                    '<p>There was an error processing the form. Please try again later.</p>';

                setTimeout(() => {
                    form.classList.remove('sending');
                }, 3000);
            });
    });
}





















